__turbopack_context__.v({
  "active": "header-nav-module-sass-module__VYkl4W__active",
  "menuIcon": "header-nav-module-sass-module__VYkl4W__menuIcon",
  "nav": "header-nav-module-sass-module__VYkl4W__nav",
});
